/**
 * Header (Delete all) + footer (Cancel / Apply) for the conditions editor.
 */

import type { FC } from 'react';
import { Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/layout/Button';

export interface ConditionsEditorHeaderProps {
  groupName: string;
  rowCount: number;
  onDeleteAll: () => void;
}

export const ConditionsEditorHeader: FC<ConditionsEditorHeaderProps> = ({
  groupName,
  rowCount,
  onDeleteAll,
}) => (
  <div className="flex items-center justify-between gap-2 border-b border-border/60 pb-1.5">
    <div className="min-w-0">
      <h4 className="truncate text-xs font-semibold text-foreground">
        Conditions — {groupName}
      </h4>
      <p className="text-[11px] leading-snug text-muted-foreground">
        Targets traffic that matches all conditions.
      </p>
    </div>
    <Button
      type="button"
      size="sm"
      variant="ghost"
      onClick={onDeleteAll}
      disabled={rowCount === 0}
      className="h-7 shrink-0 gap-1 px-2 text-destructive hover:bg-destructive/10 hover:text-destructive"
    >
      <Trash2 className="h-3.5 w-3.5" aria-hidden />
      <span>Delete all</span>
    </Button>
  </div>
);

export interface ConditionsEditorFooterProps {
  isDirty: boolean;
  onCancel: () => void;
  onApply: () => void;
}

export const ConditionsEditorFooter: FC<ConditionsEditorFooterProps> = ({
  isDirty,
  onCancel,
  onApply,
}) => (
  <div className="flex items-center justify-end gap-2 border-t border-border/60 pt-1.5">
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={onCancel}
      disabled={!isDirty}
    >
      Cancel
    </Button>
    <Button
      type="button"
      size="sm"
      onClick={onApply}
      disabled={!isDirty}
      title="Stage changes on the flow draft (still requires Apply to Voluum)"
    >
      Apply
    </Button>
  </div>
);
